import React, { Fragment, useState, useContext } from 'react';
import isEmpty from 'lodash/isEmpty';

import { ComponentContext } from '../../../context/componentContext';

import ActivityProgressBar from '../ActivityProgressBar';
import DynamicSections from './Sections/DynamicSection';
import ConditionNav from './ConditionNav';
import ConditionCard from './Conditioncard';
import Meaning from './Meaning';

import meaning from './meaning.json';

import WeatherImg from '../../../images/weather.jpg';
import AirImg from '../../../images/air.png';
import AirWhiteImg from '../../../images/air-white.svg';
import LeafImg from '../../../images/leaf.png';
import LeafWhiteImg from '../../../images/leaf-white.png';
import PressureImg from '../../../images/pressure.png';
import PressureWhiteImg from '../../../images/pressure-white.png';
import WetnessImg from '../../../images/wetness.png';
import WetnessWhiteImg from '../../../images/wetness-white.png';
import HumidityImg from '../../../images/humidity.png';
import HumidityWhiteImg from '../../../images/humidity-white.png';
import WaterImg from '../../../images/water.png';
import WaterWhiteImg from '../../../images/water-white.png';
import PercipitationImg from '../../../images/precipitation.png';
import PercipitationWhiteImg from '../../../images/precipitation-white.png';
import WindDirectionImg from '../../../images/wind1.png';
import WindDirectionWhiteImg from '../../../images/wind1-white.png';
import WindSpeedImg from '../../../images/wind2.png';
import WindSpeedWhiteImg from '../../../images/wind2-white.png';

const FarmConditions = ({ data }) => {
  const { menuOpen } = useContext(ComponentContext);

  let weather = {};
  let plant = {};
  let activity = data.feeds.filter(feed => feed.status === 'completed')[0];
  if (activity) {
    weather = activity.tasks[0].weather;
    plant = activity.tasks[0].plant;
  }

  const [view, setView] = useState('compA');
  const [dynamicData, setDynamicData] = useState('tair');

  return (
    <Fragment>
      <div className={`flex flex-wrap justify-center ${menuOpen ? 'pl-8 md:pl-24' : ''}`}>
        <div className="w-full md:w-4/5 lg:w-133">
          <div className="bg-cf-300 text-white rounded px-6 py-10 text-center">
            <h4 className="font-semibold">Welcome to your Farm Condition!</h4>
            <p className="text-sm md:text-base">
              Here, you can view all the latest updates on weather condition of your farms
            </p>
          </div>
        </div>
      </div>
      {data && data.feeds.length > 0 ? (
        <>
          <div
            className={`flex flex-wrap justify-center mt-10 px-4 md:px-0 ${
              menuOpen ? 'pl-8 md:pl-24' : ''
            }`}
          >
            <div className="w-full md:w-4/5 lg:w-3/5 bg-white rounded pt-4">
              <div className="flex flex-wrap items-center justify-between px-6">
                <div className="ml-4">
                  <h4 className="text-sm md:text-base lg:text-lg font-bold">
                    {data.farm.product.crop.name} | {data.farm.acreage} Acre(s)
                  </h4>
                  <p className="text-xs md:text-sm lg:text-base">
                    {data.farm.product.location.name}, {data.farm.product.location.state}
                  </p>
                </div>

                <div className="hidden md:block h-16 w-16 overflow-hidden rounded-full border-2 border-gray-600 xl:border-gray-300 my-3">
                  <img
                    src={data.farm.product.crop.imageUrl}
                    alt={data.farm.product.crop.name}
                    className="inline-block h-full w-full object-cover overflow-hidden rounded-bl rounded-br"
                  />
                </div>
              </div>
              <div className="px-5">
                <ActivityProgressBar
                  farmId={data.farm._id}
                  activities={data.activities}
                  duration={data.farm.product.duration}
                  startDate={data.farm.product.startDate}
                  status={data.farm.status}
                />
              </div>
              {/* TODO put a video here */}
              <img
                className="inline-block h-64 w-full object-cover mt-6"
                src={WeatherImg}
                alt="Farm Condition"
              />
            </div>
          </div>

          <div
            className={`flex flex-wrap justify-center mt-10 px-4 md:px-0 pb-16 md:pb-0 ${
              menuOpen ? 'pl-8 md:pl-24' : ''
            }`}
          >
            <div className="w-full md:w-4/5 lg:w-3/5 bg-white rounded px-6 py-4 mb-16">
              <div className="flex flex-wrap">
                <div className="w-1/6 md:w-2/6">
                  <div className="text-sm">
                    <ConditionNav
                      img={AirImg}
                      active={AirWhiteImg}
                      title="Air temperature"
                      click={() => {
                        setView('compA');
                        setDynamicData('tair');
                      }}
                      tab={view === 'compA'}
                    />

                    <ConditionNav
                      img={LeafImg}
                      active={LeafWhiteImg}
                      title="Leaf / Ground temperature"
                      click={() => {
                        setView('compB');
                        setDynamicData('tbelow');
                      }}
                      tab={view === 'compB'}
                    />

                    <ConditionNav
                      img={PressureImg}
                      active={PressureWhiteImg}
                      title="Pressure"
                      click={() => {
                        setView('compC');
                        setDynamicData('p');
                      }}
                      tab={view === 'compC'}
                    />

                    <ConditionNav
                      img={WetnessImg}
                      active={WetnessWhiteImg}
                      title="Leaf wetness"
                      click={() => {
                        setView('compD');
                        setDynamicData('lfw');
                      }}
                      tab={view === 'compD'}
                    />

                    <ConditionNav
                      img={HumidityImg}
                      active={HumidityWhiteImg}
                      title="Relative humidity"
                      click={() => {
                        setView('compE');
                        setDynamicData('rh');
                      }}
                      tab={view === 'compE'}
                    />

                    <ConditionNav
                      img={WaterImg}
                      active={WaterWhiteImg}
                      title="Actual water vapour pressure"
                      click={() => {
                        setView('compF');
                        setDynamicData('ea');
                      }}
                      tab={view === 'compF'}
                    />

                    <ConditionNav
                      img={PercipitationImg}
                      active={PercipitationWhiteImg}
                      title="Precipitation"
                      click={() => {
                        setView('compG');
                        setDynamicData('precip');
                      }}
                      tab={view === 'compG'}
                    />

                    <ConditionNav
                      img={WindDirectionImg}
                      active={WindDirectionWhiteImg}
                      title="Wind direction"
                      click={() => {
                        setView('compH');
                        setDynamicData('wind_direction');
                      }}
                      tab={view === 'compH'}
                    />

                    <ConditionNav
                      img={WindSpeedImg}
                      active={WindSpeedWhiteImg}
                      title="Wind speed"
                      click={() => {
                        setView('compI');
                        setDynamicData('wind_speed');
                      }}
                      tab={view === 'compI'}
                    />
                  </div>
                </div>
                <div className="w-5/6 md:w-4/6 md:pl-6">
                  {!isEmpty(weather) ? (
                    <div className="flex flex-col">
                      <ConditionCard
                        location={data.farm.product.location}
                        weather={weather}
                        plant={plant}
                      />
                      <DynamicSections tab={view} data={weather[dynamicData]} />
                      <Meaning manager={data.farm.product.manager} data={meaning[dynamicData]} />
                    </div>
                  ) : (
                    <div class="mt-20">
                      <h5 class="text-center">No reading recorded</h5>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          className={`flex flex-wrap justify-center mt-10 px-4 md:px-0 ${
            menuOpen ? 'md:pl-24' : ''
          }`}
        >
          <div className="text-center w-full md:w-4/5 lg:w-3/5 bg-white mb-20 px-6 py-4">
            <h5 className="text-base font-bold">No feed currently avaliable.</h5>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default FarmConditions;
